import { gql } from '@apollo/client';

import { VACANCY_FIELDS } from './fields';

export const GET_DRAFT_VACANCY = gql`
  ${VACANCY_FIELDS}
  query DraftVacancy {
    draftVacancy {
      ...vacancyFields
    }
  }
`;

export const GET_VACANCY_BY_ID = gql`
  ${VACANCY_FIELDS}
  query Vacancy($id: ID!) {
    vacancy(id: $id) {
      ...vacancyFields
    }
  }
`;
